import React from 'react'
import { Card, Col, Row, Skeleton } from 'antd'

const ROW_KEYS = ['r1', 'r2', 'r3', 'r4', 'r5']
const TILE_KEYS = ['kpi-energy', 'kpi-distribution', 'kpi-need-attention', 'kpi-avg-pto']

const TeamEnergyContentSkeleton: React.FC = () => {
  return (
    <>
      <Row gutter={[16, 16]} align="stretch" className="te-kpi-row">
        <Col xs={24} sm={12} lg={6} key={TILE_KEYS[0]}>
          <Card size="small" className="te-kpi-tile te-kpi-tile--energy">
            <div className="te-kpi-tile__energy-image">
              <Skeleton.Avatar active size={56} shape="circle" />
            </div>
            <div className="te-kpi-tile__energy-text">
              <Skeleton.Input active size="small" style={{ width: 90, height: 18 }} />
              <Skeleton.Input active size="small" style={{ width: 80, height: 14 }} />
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6} key={TILE_KEYS[1]}>
          <Card size="small" className="te-kpi-distribution">
            <Skeleton.Input active block style={{ height: 5 }} />
            <Skeleton.Input active size="small" style={{ width: 100, height: 14, marginTop: 8 }} />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6} key={TILE_KEYS[2]}>
          <Card size="small" className="te-kpi-tile">
            <Skeleton.Input active style={{ width: 60, height: 24 }} />
            <Skeleton.Input active size="small" style={{ width: 90, height: 14, marginTop: 4 }} />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6} key={TILE_KEYS[3]}>
          <Card size="small" className="te-kpi-tile">
            <Skeleton.Input active style={{ width: 70, height: 24 }} />
            <Skeleton.Input active size="small" style={{ width: 90, height: 14, marginTop: 4 }} />
          </Card>
        </Col>
      </Row>

      <Card size="small" className="te-members">
        <div className="te-members__search-row">
          <Skeleton.Input active style={{ width: 320, height: 32 }} />
        </div>
        <div className="te-members-skeleton">
          {ROW_KEYS.map((key) => (
            <div className="te-members-skeleton__row" key={key}>
              <div className="te-members-skeleton__cell te-members-skeleton__cell--name">
                <Skeleton.Avatar active size={32} />
                <Skeleton.Input active size="small" style={{ width: 140, height: 14 }} />
              </div>
              <div className="te-members-skeleton__cell">
                <Skeleton.Input active size="small" style={{ width: 72, height: 6 }} />
              </div>
              <div className="te-members-skeleton__cell">
                <Skeleton.Input active size="small" style={{ width: 80, height: 14 }} />
              </div>
              <div className="te-members-skeleton__cell">
                <Skeleton.Input active size="small" style={{ width: 60, height: 14 }} />
              </div>
              <div className="te-members-skeleton__cell">
                <Skeleton.Input active size="small" style={{ width: 60, height: 14 }} />
              </div>
              <div className="te-members-skeleton__cell">
                <Skeleton.Input active size="small" style={{ width: 70, height: 18 }} />
              </div>
            </div>
          ))}
        </div>
      </Card>
    </>
  )
}

export default TeamEnergyContentSkeleton
